/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const InstagramIcon = ({
  id,
  className,
  style: styleFromProps,
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16px"
      height="17px"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <title>instagram</title>
      <defs>
        <linearGradient
          x1="6.73139726%"
          y1="93.4846514%"
          x2="99.3669993%"
          y2="13.2938825%"
          id={`linearGradient-${id}`}
        >
          <stop stopColor="#FFDD55" offset="0%" />
          <stop stopColor="#FF543E" offset="50%" />
          <stop stopColor="#C837AB" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id={`Page-${id}`}
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="instagram" fillRule="nonzero">
          <path
            d="M1.5998144,1.685152 C0.39277504,2.938912 0.639815025,4.270752 0.639815025,8.316864 C0.639815025,11.676864 0.05357504,15.045184 3.1217344,15.838144 C4.0798144,16.084544 12.568768,16.084544 13.525568,15.836864 C14.803008,15.507264 15.842368,14.471104 15.984448,12.664384 C16.004288,12.412224 16.004288,4.225952 15.983808,3.968672 C15.832768,2.044192 14.648128,0.93507008 13.087168,0.71042944 C12.729408,0.658589696 12.657728,0.643229709 10.822208,0.640029705 C4.3114944,0.643229709 2.8842944,0.35330944 1.5998144,1.685152 Z"
            id="Path"
            fill={`url(#linearGradient-${id})`}
          />
          <path
            d="M8.318592,2.648992 C5.9947584,2.648992 3.7880384,2.442272 2.9451584,4.605472 C2.5969984,5.498912 2.6475584,6.659232 2.6475584,8.32064 C2.6475584,9.77856 2.6008384,11.1488 2.9451584,12.0352 C3.7861184,14.19968 6.0107584,13.99232 8.317312,13.99232 C10.542592,13.99232 12.836992,14.224 13.690112,12.0352 C14.038912,11.1328 13.987712,9.98976 13.987712,8.32064 C13.987712,6.104992 14.109952,4.674592 13.035392,3.600672 C11.947392,2.512672 10.476032,2.648992 8.316032,2.648992 L8.318592,2.648992 Z M7.810432,3.671072 C12.657792,3.663392 13.274752,3.124512 12.934272,10.61056 C12.813312,13.25824 10.797312,12.96768 8.319232,12.96768 C3.8008384,12.96768 3.6709184,12.8384 3.6709184,8.31808 C3.6709184,3.745312 4.0293184,3.673632 7.810432,3.669792 L7.810432,3.671072 Z M11.345792,4.612512 C10.970112,4.612512 10.665472,4.917152 10.665472,5.292832 C10.665472,5.668512 10.970112,5.973152 11.345792,5.973152 C11.721472,5.973152 12.026112,5.668512 12.026112,5.292832 C12.026112,4.917152 11.721472,4.612512 11.345792,4.612512 Z M8.318592,5.408032 C6.7102848,5.408032 5.4065984,6.712352 5.4065984,8.32064 C5.4065984,9.92896 6.7102848,11.23264 8.318592,11.23264 C9.926912,11.23264 11.229952,9.92896 11.229952,8.32064 C11.229952,6.712352 9.926912,5.408032 8.318592,5.408032 Z M8.318592,6.430112 C10.817792,6.430112 10.820992,10.2112 8.318592,10.2112 C5.8200384,10.2112 5.8161984,6.430112 8.318592,6.430112 Z"
            id="Shape"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </svg>
  );
};
